module.exports = __webpack_public_path__ + "img/PPMP10.54c924a4.png";